export default {
	chufadimudidi: 'Asal/Tujuan',
	xiugaisouxun: 'Perbaiki Pencairan',
	you: 'Dari',
	xianshi: 'Tampilkan',
	jieguo: 'Hasil',
	paixufangshi: 'Sortir Berdasarkan',
	zuipianyi: 'Termurah',
	zuikuai: 'Tercepat',
	tuiguang: 'Rekomendasi',
	tingzhan: 'Pemberhentian',
	tingzhanyi: 'Pemberhentian',
	zhifei: 'Langsung',
	yigetingzhan: 'Pemberhentian',
	duoguoliangge: 'Pemberhentian',
	meiyouchangshijian: 'Tidak ada pemberhentian lama',
	shaoyusixiaoshi: 'Kurang dari 4 Jam',
	jiagefanwei: 'Pilihan Harga',
	hanshui: 'Termasuk Pajak',
	hangbanshikebiao: 'Jadwal Penerbangan',
	tingliushijian: 'Durasi',
	tingliu: 'Durasi',
	hangkonggongsi: 'Maskapai ',
	lianmeng: 'Aliansi',
	jiebo: 'Koneksi',
	zongjia: 'Jumlah Total',
	xianzaiyuding: 'Pesan Sekarang',
	chakantanpai: 'Melihat Emisi',
	shengyu: '',
	gezuowei: 'Kursi tersisa',
	zongfeixingshijian: 'Total Durasi',
	feixingshijian: 'Waktu Penerbangan',
	hangbanxiangxixinxi: 'Rincian Penerbangan',
	xianshigengduo: 'Lihat Lebih Lanjut',
	quanxuan: 'Pilih Semua',
	qingchu: 'Hapus',
	xuanzenindefukuanfangshi: 'Pilih Metode Pembayaran',
	xinyongkajiejika: 'Kartu Kredit/Debit',
	qingshurunindexiangxixinxi: 'Silahkan Masukkan Detail kartu kredit/debit',
	youxiaoriqi: 'Tanggal Kadaluarsa',
	xinyongkajiejikakahao: 'Kartu Kredit / Debit',
	kayanzhengma: 'Nomor Verifikasi Kartu',
	yanzhengmatishi: '3 digit angka kode verifikasi kartu (CVC) akan muncul pada kotak tanda tangan atau pada kotak putih di bagian tanda tangan dibelakang kartu.',
	dianziyoujian: 'Alamat Email (Tidak Wajib)',
	lijifukuan: 'Bayar Sekarang',
	quxiaobingfanhui: 'Batal dan Kembali',
	wuxiaoka: 'Kartu tidak Sah',
	yichang: 'Transaksi Gagal, Silahkan menghubungi layanan pelanggan bank untuk menyelesaikan masalah.',
	jiagefashengbiandong: 'Harga sudah berubah, kami akan mencari penerbangan lain',
	ren: 'passenger',
	chengkepingjunjiage: 'Avg price per passenger',
};
